import { EventDetails } from 'types/Event'

import { Container, TicketDataLabel, Title } from './ticketScan.style'

interface Props {
    event: EventDetails
}

export const CheckAuditoriumGeneralSelling = ({ event }: Props) => {
    const arrived = Number(event.number_of_arrived_tickets ?? 0)
    const sold = Number(event.number_of_sold_tickets ?? 0)
    const total = arrived + sold

    return (
        <Container>
            <Title>Nézőtér telítettsége</Title>
            <TicketDataLabel>{`${arrived}/${total}`}</TicketDataLabel>
        </Container>
    )
}
